var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87 2.299a.994.994 0 011.413 0 1.06 1.06 0 010 1.454l-3.876 4 3.876 4a1.06 1.06 0 010 1.454.994.994 0 01-1.413 0L4.295 8.481a1.052 1.052 0 010-1.462z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6228",
    fill: "none",
    d: "M0 0h16v16H0z"
  })));
}
export default SvgArrowSmallLeft;